document.addEventListener('cart:built', function(evt) {
  var subtotal = evt.detail.total;
  var freeShipping = 5000;
  var percent = subtotal / 50;
  var remaining = Math.round(5000 - subtotal);
  
  if (subtotal < 5000) {
    document.querySelector('.free_shipping_footer').classList.remove('free_shipping_footer--visible');
    document.querySelector('.free_shipping').innerHTML = "<div>You're <span>"+ theme.Currency.formatMoney(remaining, theme.settings.moneyFormat) +"</span> from getting <strong>Free US Shipping</strong>.</div><div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:"+percent+"%'></div></div>";
  }else{
    document.querySelector('.free_shipping_footer').classList.add('free_shipping_footer--visible');
    document.querySelector('.free_shipping').innerHTML = "<div>Congratulations! <strong>Free EU Shipping!</strong>.</div><div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:100%'></div></div>";
  }
});